import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { apiService } from '@/services/api/apiService';

interface CustomSearchFoodMenuItemSlice {
    foodMenuName: string | undefined;
    menuDescription: any;
    imageUrl: string | undefined;
    customDescription: any;
    id: number | null | undefined;
    isActive: boolean;
    basePrice: number;
    createdAt: string;
    dietTypeId: number;
    foodMenuId: number;
    auditTrailId: number | null;
    cookProfileId: number;
    approvalStatusId: number;
}

interface CustomSearchFoodMenuItemState {
    data: CustomSearchFoodMenuItemSlice[];
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_COOK_PORT;
const URL = import.meta.env.VITE_API_COOK_URL;

export const customSearchFoodMenuItem = createAsyncThunk<
    CustomSearchFoodMenuItemSlice[],
    { cookProfileId: any },
    { rejectValue: string }
>(
    'CustomSearchFoodMenuItem/customSearchFoodMenuItem',
    async (params, { rejectWithValue }) => {
        try {
            const config = { params };
            const response = await apiService.get<any>(
                'custom_search_food_menu_item',
                PORT,
                URL,
                config
            );
            return response.data.data;
        } catch (error: any) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }
);

const initialState: CustomSearchFoodMenuItemState = {
    data: [],
    loading: false,
    error: null,
};

export const customSearchFoodMenuItemSlice = createSlice({
    name: 'CustomSearchFoodMenuItem',
    initialState,
    reducers: {
        clear: (state) => {
            state.data = [];
            state.error = null;
            state.loading = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(customSearchFoodMenuItem.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(
                customSearchFoodMenuItem.fulfilled,
                (state, action: PayloadAction<CustomSearchFoodMenuItemSlice[]>) => {
                    state.loading = false;
                    state.data = action.payload;
                }
            )
            .addCase(customSearchFoodMenuItem.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch food items';
            });
    },
});

export default customSearchFoodMenuItemSlice.reducer;
export const { clear } = customSearchFoodMenuItemSlice.actions;
